// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.OnboardingCard__root--vTTQ9 {
    background: #1E2028;
    padding: 24px 24px 66px;
}

    @media screen and (min-width: 768px) and (max-width: 1024px), screen and (min-width: 1024px) and (max-width: 1381px) {.OnboardingCard__root--vTTQ9 {
        display: grid;
        grid-gap: 20px;
        padding: 24px
}
    }

    @media screen and (min-width: 768px) and (max-width: 1024px) {.OnboardingCard__root--vTTQ9 {
        grid-template-columns: 260px auto
}
    }

    @media screen and (min-width: 1024px) and (max-width: 1381px) {.OnboardingCard__root--vTTQ9 {
        grid-template-columns: 400px auto
}
    }

    @media screen and (min-width: 1380px) {.OnboardingCard__root--vTTQ9 {
        padding: 48px;
        display: grid;
        grid-template-columns: 460px auto;
        grid-gap: 24px
}
    }

.OnboardingCard__infoWrapper--rKVxn {
    padding-top: 48px;
}

@media screen and (min-width: 768px) and (max-width: 1024px) {

.OnboardingCard__infoWrapper--rKVxn {
        padding-top: 88px
}
    }

@media screen and (min-width: 1024px) {

.OnboardingCard__infoWrapper--rKVxn {
        padding-top: 60px
}
    }

.OnboardingCard__name--uuZ9p {
    font-weight: 500;
    font-size: 16px;
    line-height: 20px;
    color: var(--tertiary-color);
    margin-bottom: 12px;
}

@media screen and (min-width: 768px) and (max-width: 1024px), screen and (min-width: 1024px) {

.OnboardingCard__name--uuZ9p {
        font-size: 20px;
        line-height: 24px
}
    }

.OnboardingCard__description--kQiSC {
    font-weight: 400;
    font-size: 16px;
    line-height: 24px;
    color: #85909D;
    min-height: 72px;
    margin-bottom: 8px;
}

@media screen and (min-width: 768px) and (max-width: 1024px), screen and (min-width: 1024px) {

.OnboardingCard__description--kQiSC {
        margin-bottom: 24px
}
    }

.OnboardingCard__steps--PBdh7 {
    width: 100%;
    overflow: hidden;
    display: flex;
    grid-gap: 20px;
}

.OnboardingCard__step--GxbKe {
    background: #111319;
    border-radius: 6px;
    border: 1px solid #111319;
    width: 100%;
    display: flex;
    flex-direction: column;
    overflow: hidden;
    flex-shrink: 0;
}

@media screen and (min-width: 768px) and (max-width: 1024px), screen and (min-width: 1024px) {

.OnboardingCard__step--GxbKe {
        width: calc(50% - 10px);
        min-width: 360px
}
    }

.OnboardingCard__stepIndex--j8y8e {
    font-weight: 500;
    font-size: 12px;
    line-height: 16px;
    letter-spacing: 0.05em;
    text-transform: uppercase;
    color: var(--tertiary-color);
    padding: 20px 20px 0;
}

.OnboardingCard__stepCurrentIndex--VgHW2 {
    color: var(--secondary-color);
}

.OnboardingCard__stepDescription--QEOH8 {
    font-weight: 500;
    font-size: 9px;
    line-height: 12px;
    letter-spacing: 0.1em;
    text-transform: uppercase;
    color: var(--tertiary-color);
    padding: 0 20px;
    min-height: 40px;

}

.OnboardingCard__stepImage--qyf_H {
    width: 100%;
    height: auto;
}

@media screen and (min-width: 1380px) {

.OnboardingCard__stepImage--qyf_H {
        -o-object-fit: cover;
           object-fit: cover;
        -o-object-position: top;
           object-position: top;
        height: 154px
}
    }
`, "",{"version":3,"sources":["webpack://./src/ui-v2/components/CS/OnboardingCard/OnboardingCard.css"],"names":[],"mappings":"AAAA;IACI,mBAAmB;IACnB,uBAAuB;AAsB3B;;IApBI,sHAJJ;QAKQ,aAAa;QACb,cAAc;QACd;AAiBR;IAhBI;;IAEA,8DAVJ;QAWQ;AAaR;IAZI;;IAEA,+DAdJ;QAeQ;AASR;IARI;;IAEA,uCAlBJ;QAmBQ,aAAa;QACb,aAAa;QACb,iCAAiC;QACjC;AAER;IADI;;AAGJ;IACI,iBAAiB;AASrB;;AAPI;;AAHJ;QAIQ;AAMR;IALI;;AAEA;;AAPJ;QAQQ;AAER;IADI;;AAGJ;IACI,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,4BAA4B;IAC5B,mBAAmB;AAMvB;;AAJI;;AAPJ;QAQQ,eAAe;QACf;AAER;IADI;;AAGJ;IACI,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,cAAc;IACd,gBAAgB;IAChB,kBAAkB;AAKtB;;AAHI;;AARJ;QASQ;AAER;IADI;;AAGJ;IACI,WAAW;IACX,gBAAgB;IAChB,aAAa;IACb,cAAc;AAClB;;AAEA;IACI,mBAAmB;IACnB,kBAAkB;IAClB,yBAAyB;IACzB,WAAW;IACX,aAAa;IACb,sBAAsB;IACtB,gBAAgB;IAChB,cAAc;AAMlB;;AAJI;;AAVJ;QAWQ,uBAAuB;QACvB;AAER;IADI;;AAGJ;IACI,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,sBAAsB;IACtB,yBAAyB;IACzB,4BAA4B;IAC5B,oBAAoB;AACxB;;AAEA;IACI,6BAA6B;AACjC;;AAEA;IACI,gBAAgB;IAChB,cAAc;IACd,iBAAiB;IACjB,qBAAqB;IACrB,yBAAyB;IACzB,4BAA4B;IAC5B,eAAe;IACf,gBAAgB;;AAEpB;;AAEA;IACI,WAAW;IACX,YAAY;AAOhB;;AALI;;AAJJ;QAKQ,oBAAiB;WAAjB,iBAAiB;QACjB,uBAAoB;WAApB,oBAAoB;QACpB;AAER;IADI","sourcesContent":[".root {\n    background: #1E2028;\n    padding: 24px 24px 66px;\n\n    @media (--small-tablet), (--tablet) {\n        display: grid;\n        grid-gap: 20px;\n        padding: 24px;\n    }\n\n    @media (--small-tablet) {\n        grid-template-columns: 260px auto;\n    }\n\n    @media (--tablet) {\n        grid-template-columns: 400px auto;\n    }\n\n    @media (--desktop-only) {\n        padding: 48px;\n        display: grid;\n        grid-template-columns: 460px auto;\n        grid-gap: 24px;\n    }\n}\n\n.infoWrapper {\n    padding-top: 48px;\n\n    @media (--small-tablet) {\n        padding-top: 88px;\n    }\n\n    @media (--large) {\n        padding-top: 60px;\n    }\n}\n\n.name {\n    font-weight: 500;\n    font-size: 16px;\n    line-height: 20px;\n    color: var(--tertiary-color);\n    margin-bottom: 12px;\n\n    @media (--small-tablet), (--large) {\n        font-size: 20px;\n        line-height: 24px;\n    }\n}\n\n.description {\n    font-weight: 400;\n    font-size: 16px;\n    line-height: 24px;\n    color: #85909D;\n    min-height: 72px;\n    margin-bottom: 8px;\n\n    @media (--small-tablet), (--large) {\n        margin-bottom: 24px;\n    }\n}\n\n.steps {\n    width: 100%;\n    overflow: hidden;\n    display: flex;\n    grid-gap: 20px;\n}\n\n.step {\n    background: #111319;\n    border-radius: 6px;\n    border: 1px solid #111319;\n    width: 100%;\n    display: flex;\n    flex-direction: column;\n    overflow: hidden;\n    flex-shrink: 0;\n\n    @media (--small-tablet), (--large) {\n        width: calc(50% - 10px);\n        min-width: 360px;\n    }\n}\n\n.stepIndex {\n    font-weight: 500;\n    font-size: 12px;\n    line-height: 16px;\n    letter-spacing: 0.05em;\n    text-transform: uppercase;\n    color: var(--tertiary-color);\n    padding: 20px 20px 0;\n}\n\n.stepCurrentIndex {\n    color: var(--secondary-color);\n}\n\n.stepDescription {\n    font-weight: 500;\n    font-size: 9px;\n    line-height: 12px;\n    letter-spacing: 0.1em;\n    text-transform: uppercase;\n    color: var(--tertiary-color);\n    padding: 0 20px;\n    min-height: 40px;\n\n}\n\n.stepImage {\n    width: 100%;\n    height: auto;\n\n    @media (--desktop-only) {\n        object-fit: cover;\n        object-position: top;\n        height: 154px;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"root": `OnboardingCard__root--vTTQ9`,
	"infoWrapper": `OnboardingCard__infoWrapper--rKVxn`,
	"name": `OnboardingCard__name--uuZ9p`,
	"description": `OnboardingCard__description--kQiSC`,
	"steps": `OnboardingCard__steps--PBdh7`,
	"step": `OnboardingCard__step--GxbKe`,
	"stepIndex": `OnboardingCard__stepIndex--j8y8e`,
	"stepCurrentIndex": `OnboardingCard__stepCurrentIndex--VgHW2`,
	"stepDescription": `OnboardingCard__stepDescription--QEOH8`,
	"stepImage": `OnboardingCard__stepImage--qyf_H`
};
export default ___CSS_LOADER_EXPORT___;
